import { render, staticRenderFns } from "./tabDeclarationScope.vue?vue&type=template&id=2c8b53e1&scoped=true&"
import script from "./tabDeclarationScope.vue?vue&type=script&lang=js&"
export * from "./tabDeclarationScope.vue?vue&type=script&lang=js&"
import style0 from "./tabDeclarationScope.vue?vue&type=style&index=0&id=2c8b53e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8b53e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c8b53e1')) {
      api.createRecord('2c8b53e1', component.options)
    } else {
      api.reload('2c8b53e1', component.options)
    }
    module.hot.accept("./tabDeclarationScope.vue?vue&type=template&id=2c8b53e1&scoped=true&", function () {
      api.rerender('2c8b53e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/aviationExchangePriceBatch/tab/tabDeclarationScope.vue"
export default component.exports